import { render, staticRenderFns } from "./invoiceInfoDetail.vue?vue&type=template&id=2289503e"
import script from "./invoiceInfoDetail.vue?vue&type=script&lang=js"
export * from "./invoiceInfoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports